import SidebarNav from './SidebarNav';
import SidebarProfile from './SidebarProfile';
import CompleteProfile from './CompleteProfile';

interface IProps {
  isSidebarOpen: boolean;
  setIsSidebarOpen: (isSidebarCollapsed: boolean) => void;
}

const Sidebar = (props: IProps) => {
  const { setIsSidebarOpen, isSidebarOpen } = props;

  return (
    <>
      <SidebarNav
        isSidebarOpen={isSidebarOpen}
        setIsSidebarOpen={setIsSidebarOpen}
      />
      <div>
        {isSidebarOpen  && <CompleteProfile />}
        <SidebarProfile isSidebarOpen={isSidebarOpen} />
      </div>
    </>
  );
};

export default Sidebar;
